/** Custom event + postMessage type to open the shared Help Desk modal. */
export const OPEN_HELP_DESK_EVENT = "magicnotes:open-help-desk";
export const OPEN_HELP_DESK_POST_MESSAGE_TYPE = "OPEN_HELP_DESK";

let registeredOpen = null;

/** Register the app-wide Help Desk modal opener (HelpDeskModal on mount). */
export function registerHelpDeskOpen(openFn) {
  registeredOpen = openFn;
  return () => {
    if (registeredOpen === openFn) {
      registeredOpen = null;
    }
  };
}

/** Open the Help Desk modal popup from anywhere in the app. */
export function openHelpDeskModal() {
  if (typeof registeredOpen === "function") {
    registeredOpen();
    return;
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(OPEN_HELP_DESK_EVENT));
  }
}
